import React, { forwardRef } from 'react';
import { NavLink } from 'react-router-dom';

const WrapLink = forwardRef((props, ref) => <NavLink {...props} ref={ref} />);

export default WrapLink;
